import { useState, useEffect } from 'react'
import { Event } from '../../types/intellijetnet'
import { EventsService } from '../../services/intellijetnet/events.service'

export function useEvents(aircraftId?: number) {
  const [data, setData] = useState<Event[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!aircraftId) {
      setData([])
      setLoading(false)
      return
    }

    async function fetchData() {
      try {
        setLoading(true)
        setError(null)
        const events = await EventsService.getByAircraftId(aircraftId!)
        setData(events)
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch events'))
        setData([])
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [aircraftId])

  return { data, loading, error }
}

export function useEventsFiltered(params?: {
  modelId?: number
  startDate?: string
  endDate?: string
  subject?: string
}) {
  const [data, setData] = useState<Event[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!params?.modelId) {
      setData([])
      setLoading(false)
      return
    }

    async function fetchData() {
      try {
        setLoading(true)
        setError(null)
        
        let query = EventsService.query()
          .eq('model_id', params!.modelId!)
          .eq('is_active', true)
          .order('date', false)
        
        if (params!.startDate) {
          query = query.gte('date', params!.startDate)
        }
        
        if (params!.endDate) {
          query = query.lte('date', params!.endDate)
        }
        
        if (params!.subject) {
          query = query.eq('subject', params!.subject)
        }
        
        const { data: events } = await query.execute<Event>()
        setData(events)
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch events'))
        setData([])
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.modelId, params?.startDate, params?.endDate, params?.subject])

  return { data, loading, error }
}